import { DOMAIN, useCanViewCommitteesBool } from "@/hooks/useCapabilities";
import { useFlags, type FlagRecord } from "@/hooks/useFeatureFlags";
import type { NavLink } from "@/layouts/AppLayout/types";
import type { Path } from "@/router";
import { COMMITTEES_BASE_PATH } from "@/pages/people/membership-services/committees/constants";

export const isApplicationsMembershipEnabled = (flags: FlagRecord = {}) => flags["applications-membership"] === true;

export const getMembershipServicesNavLinks = (
  flags: FlagRecord = {},
  { canViewCommittees = false }: { canViewCommittees?: boolean } = {}
): NavLink<Path>[] => {
  const links: NavLink<Path>[] = [
    {
      domain: DOMAIN.EVERYONE,
      label: "Applications",
      link: { to: "/people/membership-services/applications" },
      icon: "article"
    },
    {
      domain: DOMAIN.EVERYONE,
      label: "Achievements",
      link: { to: "/people/membership-services/achievements-report" },
      icon: "emoji_events"
    },
    ...(isApplicationsMembershipEnabled(flags)
      ? [
          {
            domain: DOMAIN.EVERYONE,
            label: "Member Elections",
            link: { to: "/people/membership-services/member-elections" as const },
            icon: "how_to_vote" as const
          }
        ]
      : [])
  ];

  if (canViewCommittees) {
    links.push({
      domain: DOMAIN.PEOPLE,
      label: "Committees",
      link: {
        to: COMMITTEES_BASE_PATH
      },
      icon: "groups"
    });
  }

  return links;
};

export const useMembershipServicesNavLinks = () => {
  const flags = useFlags();
  const canViewCommittees = useCanViewCommitteesBool();

  return getMembershipServicesNavLinks(flags, { canViewCommittees });
};
